// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-chip[data-v-321ccc49]{-webkit-transition:all .2s ease;transition:all .2s ease}.v-chip[data-v-321ccc49]:hover{-webkit-transform:scale(1.15);transform:scale(1.15)}.btn-download-badge .v-badge__badge[data-v-321ccc49]{font-size:12px!important;font-weight:700!important;min-width:22px!important;height:22px!important;border-radius:11px!important}.btn-download-badge:hover .v-badge__badge[data-v-321ccc49]{-webkit-transform:scale(1.1);transform:scale(1.1)}", ""]);
// Exports
module.exports = exports;
